import { useFormContext } from '@/Hooks/useFormWrapper';
import { useRequired } from '@/Hooks/Validation';
import { FormData } from '@/ModalWindows/OrderAutomatizationModal/hooks/useOrderAutomatizationModalForm';
import { OrderAutomatizationPackageModel } from '@/Models/OrderUserProducts/OrderAutomatizationPackageModel';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { orderAutomatizationAsyncActions } from '@/ModalWindows/OrderAutomatizationModal/services/reducer';
import { useDispatch } from 'react-redux';

export const usePackageRowForm = (
  rowIndex: number,
  index: number,
  packages: OrderAutomatizationPackageModel[],
  orderId?: number,
) => {
  const dispatch = useDispatch();

  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<FormData>();

  const required = useRequired();
  const [isPackageChanged, setIsPackageChanged] = useState(false);

  const selectedPackageKey = watch(`prepareLabels.${rowIndex}.packages.${index}.key`);
  const selectedProductId = watch(`prepareLabels.${rowIndex}.userProductId`);

  const selectedPackage = useMemo(() => {
    if (selectedPackageKey) {
      return packages?.find((p) => p.key === selectedPackageKey);
    } else {
      return packages?.find((p) => p.isDefault);
    }
  }, [packages, selectedPackageKey]);

  useEffect(() => {
    register(`prepareLabels.${rowIndex}.packages.${index}.price`);
  }, []);

  useEffect(() => {
    if (selectedPackageKey) {
      setIsPackageChanged(true);
    }
  }, [selectedPackageKey]);

  useEffect(() => {
    if (selectedPackage) {
      const selectedProduct = selectedPackage.products?.find((p) => {
        return p.id === selectedProductId;
      });

      setValue(`prepareLabels.${rowIndex}.packages.${index}.price`, selectedProduct?.userProductPrice ?? 0);
      setValue(`prepareLabels.${rowIndex}.packages.${index}.key`, selectedPackage.key, { shouldValidate: true });
      setValue(`prepareLabels.${rowIndex}.packages.${index}.weight`, selectedPackage.weight, { shouldValidate: true });
    } // if
  }, [selectedPackage, selectedProductId]);

  const loadProducts = useCallback(() => {
    if (orderId && selectedPackage) {
      const { packageId } = selectedPackage;
      dispatch(orderAutomatizationAsyncActions.getLogisticProducts({ orderId, packageId }));
    }

    setIsPackageChanged(false);
  }, [selectedPackage]);

  return {
    methods: {
      register,
      setValue,
      watch,
      errors,
      loadProducts,
    },
    rules: {
      required,
    },
    options: {
      isPackageChanged,
    },
  };
};
